module.exports =
  ru:
    income: 'доход'
    incomes: 'доходы'
    expense: 'расход'
    expenses: 'расходы'
    net: 'разница'
    transfer: 'перевод'
    transfers: 'переводы'
    transfer_accounts: 'между счетами'
    transfer_virtuals: 'между конвертами'
    HoneyMoney: 'ХаниМани'
    HM: 'ХМ'
    Reserves: 'Резервы'
    Funds: 'Фонды'
    Fund: 'Фонд'
    Goals: 'Цели'
    Goal: 'Цель'
    Total: 'Всего'
    Accounts: 'Счета'
    Account: 'Счёт'
    Envelopes: 'Конверты'
    Envelope: 'Конверт'
    Balance: 'Баланс'
    Name: 'Название'
    Description: 'Описание'
    optional: 'необязательно'
    Reports: 'Отчёты'
    Transactions: 'Транзакции'
    Calendar: 'Календарь'
    'Accounts and Envelopes': 'Счета и Конверты'
    'Category / Subcategory': 'Категория / подкатегория'
    List: 'Список'
    'By Months': 'По месяцам'
    'Net Worth': 'Всего денег'
    'Budget': 'Включить в баланс'
    'Off-Budget': 'Исключить из баланса'
    Save: 'Сохранить'
    Cancel: 'Отмена'
    delete: 'Удалить'
    do_not_delete: 'Не удалять'
    do_delete: 'Да, удалить'
    Hide: 'Скрыть'
    Categories: 'Категории'
    Subcategories: 'Подкатегории'
    Done: 'Готово'
    name_is_required: 'Введите название'
    balance_is_required: 'Введите текущий баланс'
    balance_is_number: 'Баланс должен быть числом'
    'First Name': 'Имя'
    'Week starts': 'Начало недели'
    Sunday: 'Воскресенье'
    Monday: 'Понедельник'
    'Default currency': 'Основная валюта'
    Password: 'Пароль'
    'Password confirmation': 'Пароль ещё раз'
    'New Account': 'Новый счёт'
    'New Envelope': 'Новый конверт'
    'Sign out': 'Выход'
    filter: 'фильтр'
    'hide filter': 'скрыть фильтр'
    offline: 'ОФФЛАЙН'
    Real: 'Факт'
    Plan: 'План'
    "What's new?": 'Что нового?'
    'surplus in Reserves': 'лишние в Резервах'
    'not enough in Reserves': 'не хватает в Резервах'
    'Categories Editor': 'Редактор категорий'
    'Exchange Rates': 'Курсы валют'
    'No category': 'Без категории'
    'show more': 'показать ещё'
    chart_example: 'Пример графика'
    Date: 'Дата'
    Amount: 'Сумма'
    Category: 'Категория'
    Description: 'Описание'
    Create: 'Создать'
  en:
    offline: 'OFFLINE'
    transfer_accounts: 'between accounts'
    transfer_virtuals: 'between envelopes'
    balance_is_required: 'Balance is required'
    balance_is_number: 'Balance must be a number'
    name_is_required: 'Name is required'
    delete: 'Delete'
    do_not_delete: 'Do not delete'
    do_delete: 'Yes, delete'
    chart_example: 'Chart Example'
